/** Shared ease-out curve of the vendored Beautiful UI motion. */
export const BUI_EASE = 'cubic-bezier(0.23, 1, 0.32, 1)'

/** True when the user asked the OS to reduce motion. */
export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
